<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">

      <div class="card headertop">
        <div class="card-header">

          <div class="card-body" style="margin:auto;" v-if="role === 'agent'">
            <form>
              <div class="row" style="margin:auto;">
                <div class="col-md-2">
                  <fg-input type="text"
                            label="Supplier"
                            required
                            v-model="terminal.supplier">
                  </fg-input>
                </div>
                <div class="col-md-2">

                  <fg-input type="text"
                            label="Type"
                            required
                            v-model="terminal.type">
                  </fg-input>
                </div>
                <div class="col-md-2">
                  <fg-input label="Usable" required>
                    <el-select class="select-primary"
                               size="large"
                               placeholder="Single Select"
                               v-model="terminal.usable">

                      <el-option value="true" label="YES">

                      </el-option>
                      <el-option value="false" label="NO">

                      </el-option>
                    </el-select>
                  </fg-input>
                </div>
                <div class="col-md-2" style="margin:auto">
                <button type="submit" class="btn btn-success btn-fill" style="margin-top: 25px;" @click.prevent="createTerminal">
                  Update
                </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default {

    components: {

    },
    data () {
      return {
        terminal: { supplier : '', type: '', usable: ''},
        role: localStorage.role,
      }
    },
    mounted() {
    },
    methods: {
      createTerminal() {
        if(this.terminal.supplier != '' && this.terminal.type != '' && this.terminal.usable != '') {
          this.$http({
            method: 'post',
            url: this.$apiUrl + '/terminal/terminal',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            params: this.terminal,
          }).then(response => (
                  this.$notify({
                    message: 'terminal created',
                    type: 'success',
                    horizontalAlign: 'center',
                    verticalAlign: 'top'
                  }),
                          this.$router.push({path: '/search/terminals'})
          )).catch(err => {
            console.log(err),
                    this.$notify({
                      message: 'Impossible to create this terminal',
                      type: 'danger',
                      horizontalAlign: 'center',
                      verticalAlign: 'top'
                    })
          })
        } else {
          this.$notify({
            message: 'Fill the form',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        }



      }
    }
  }

</script>

<style scoped>

</style>
